import React from 'react'
import { usePostRequest } from '../hooks/request'
import { DUE_ITEM_LIST } from '../urls'
import DueItemForm from './DueItemForm'

export default function DueItemCreate({ onCancel, onSuccess, finance, dueDate }) {
    const monthCreate = usePostRequest({ url: DUE_ITEM_LIST.replace('{dueDateId}', finance.id) })

    async function onSubmit(data) {
        const { success } = await monthCreate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Добавить</b><br /><br />
            <DueItemForm
                finance={finance}
                dueDate={dueDate}
                onSubmit={onSubmit}
                onCancel={onCancel}
                loading={monthCreate.loading} />
        </div>
    )
}
